// Stripe redirects here after a successful checkout.
// Stripe handles the receipt; this is just a warm "thank you" landing.

import { Link } from "react-router-dom";
import { Coffee } from "lucide-react";
import { Wordmark } from "../components/Brand";
import { Card, CardBody } from "../components/ui/Card";
import { Button } from "../components/ui/Button";

export function SupportThanks() {
  return (
    <div className="min-h-full bg-bg flex flex-col">
      <header className="border-b border-border bg-surface">
        <div className="mx-auto max-w-3xl px-5 h-14 flex items-center">
          <Link to="/" className="block"><Wordmark size="sm" /></Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-12">
        <Card className="w-full max-w-md">
          <CardBody className="text-center">
            <div className="h-14 w-14 rounded-2xl bg-primary-soft border border-primary/15 flex items-center justify-center mx-auto">
              <Coffee className="h-6 w-6 text-primary" />
            </div>
            <h1 className="mt-5 text-2xl font-semibold tracking-tight">Thanks for the coffee.</h1>
            <p className="mt-3 text-text-muted leading-relaxed">
              Genuinely — that keeps Carol Care running for every family using it.
              Your receipt is on its way from Stripe.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/">
                <Button variant="secondary">Back to home</Button>
              </Link>
              <Link to="/app">
                <Button>Open the app</Button>
              </Link>
            </div>
          </CardBody>
        </Card>
      </main>
    </div>
  );
}
